<template>
    <div>
        <template v-if="$auth.check()">
            <AppSidebar/>

            <div class="content-wrapper">
                <AlertMsg/>
                <router-view/>
            </div>
        </template>

        <template v-else>
            <div class="container-fluid">
                <router-view/>
            </div>
        </template>
    </div>
</template>

<script>
import AppSidebar from './AppSidebar'
import AlertMsg from './AlertMsg'

export default {
  name: 'App',

  components: {
    AppSidebar,
    AlertMsg
  },

  computed: {
    user () {
      return this.$auth.user()
    }
  }
}
</script>
